import { focusAtom } from 'jotai-optics';

import { currentSearchAtom } from './Search';

export const filterAtom = focusAtom(currentSearchAtom, (optic) =>
    optic.prop('filter')
);

export const accommodationAtom = focusAtom(filterAtom, (optic) =>
    optic.prop('accommodation')
);

export const roomTypeListAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('roomTypeList')
);

export const hotelCategoryAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('hotelCategoryList')
);

export const guestRatingAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('rating')
);

export const mealTypeAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('mealTypeList')
);

export const budgetAtom = focusAtom(filterAtom, (optic) =>
    optic.prop('budget')
);

export const flightAtom = focusAtom(filterAtom, (optic) =>
    optic.prop('flight')
);

export const accommodationTypeAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('accommodationCategoryList')
);

export const directFlightAtom = focusAtom(flightAtom, (optic) =>
    optic.prop('directFlight')
);

export const withNoBagAtom = focusAtom(flightAtom, (optic) =>
    optic.prop('withNoBag')
);

export const departureFlightTimeAtom = focusAtom(flightAtom, (optic) =>
    optic.prop('departureFlightTime')
);

export const returnFlightTimeAtom = focusAtom(flightAtom, (optic) =>
    optic.prop('returnFlightTime')
);

export const paymentTypeListAtom = focusAtom(filterAtom, (optic) =>
    optic.prop('paymentTypeList')
);

export const specialAtom = focusAtom(filterAtom, (optic) =>
    optic.prop('special')
);

export const cancellationAtom = focusAtom(specialAtom, (optic) =>
    optic.prop('cancellation')
);

export const rebookableAtom = focusAtom(specialAtom, (optic) =>
    optic.prop('rebookable')
);

export const reservableAtom = focusAtom(specialAtom, (optic) =>
    optic.prop('reservable')
);
export const lowDepositAtom = focusAtom(specialAtom, (optic) =>
    optic.prop('lowDeposit')
);

export const promoDiscountAtom = focusAtom(specialAtom, (optic) =>
    optic.prop('promoDiscount')
);

export const tourOperatorCategoryListAtom = focusAtom(filterAtom, (optic) =>
    optic.prop('tourOperatorCategoryList')
);

export const tourOperatorListAtom = focusAtom(filterAtom, (optic) =>
    optic.prop('tourOperatorList')
);

export const transferAtom = focusAtom(filterAtom, (optic) =>
    optic.prop('transfer')
);

export const hotelTransferAtom = focusAtom(transferAtom, (optic) =>
    optic.prop('hotelTransfer')
);

export const privateTransferAtom = focusAtom(transferAtom, (optic) =>
    optic.prop('privateTransfer')
);

export const railAndFlyAtom = focusAtom(transferAtom, (optic) =>
    optic.prop('railAndFly')
);

export const attributeListAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('attributesList')
);

export const viewTypeListAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('viewTypeList')
);

export const poolTypeListAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('poolTypeList')
);

export const exteriorAtom = focusAtom(accommodationAtom, (optic) =>
    optic.prop('exteriorList')
);
